import { useEffect, useState } from "react";
import "./style.scss";
import { trans } from "utils/helpers";
import { useLocation } from "react-router-dom";

interface SwitchBtnProps {
  handleModeCard: (e: boolean) => void;
  cardStyle?: boolean;
  setColor?: "defaultColor" | "customerColor";
  setShape?: "Square" | "circle";
  firstMode: string;
  secondMode: string;
  bottomSpace?: any;
  parentModalName?: any;
  treeMode?: boolean;
}

export const SwitchBtn = ({
  handleModeCard,
  treeMode=false,
  parentModalName,
  bottomSpace = false,
  firstMode,
  secondMode,
  setColor = "defaultColor",
  setShape = "Square",
}: SwitchBtnProps) => {
  const location = useLocation();
   let pathName
  if(parentModalName){
  pathName= parentModalName
  }else{
 pathName =location?.pathname?.split("/")?.[
        location?.pathname?.split("/")?.length - 1
      ]
  }
  const [selectedTreeOrCard, setSelectedTreeOrCard] = useState<any>(true);
  const chanegMode = () => {
    handleModeCard(!selectedTreeOrCard);
    setSelectedTreeOrCard(!selectedTreeOrCard);
    if (treeMode) {
      localStorage.setItem(
        "treeOrList",
        JSON.stringify({
          ...JSON.parse(localStorage.getItem("treeOrList") as any),
          [pathName]: !selectedTreeOrCard,
        })
      );
    } else {
      localStorage.setItem(
        "cardOrList",
        JSON.stringify({
          ...JSON.parse(localStorage.getItem("cardOrList") as any),
          [pathName]: !selectedTreeOrCard,
        })
      );
    }
  };


  useEffect(() => {
    const dataOfStorage=treeMode
      ? JSON.parse(localStorage.getItem("treeOrList") as any)?.[pathName]
      : JSON.parse(localStorage.getItem("cardOrList") as any)?.[pathName]

    if (treeMode && localStorage.getItem("treeOrList") && (dataOfStorage!==null && dataOfStorage!==undefined)) {
      setSelectedTreeOrCard(
        dataOfStorage
      );
      
    handleModeCard( dataOfStorage);

    } else if (!treeMode && localStorage.getItem("cardOrList")  &&  (dataOfStorage!==null && dataOfStorage!==undefined)
  ) {

    setSelectedTreeOrCard(
        dataOfStorage
      );
    handleModeCard( dataOfStorage);

    }else{


    handleModeCard(true);//برای وقتی توی لوکال استرج چیزی نداریم و باید مقدار فعلی استیت و بفرستیم بالا چون کامپوننت والد منتظر مقدار هست که دیتا رو بگیره بر اساس نوع درختی/کارتی  یا لیستی

    }
  }, [
    treeMode
      ? JSON.parse(localStorage.getItem("treeOrList") as any)?.[pathName]
      : JSON.parse(localStorage.getItem("cardOrList") as any)?.[pathName],
  ]);

  return (
    <div
      style={{ maxWidth: "175px" }}
      className="d-flex justify-content-between align-items-center p-1"
    >
      <div style={{ fontSize: "12px" }} className="ms-2 userSelectNone">
        {trans(firstMode)}
      </div>
      <div
        className="switchBtn"
        onClick={() => {
          chanegMode();
        }}
      >
        <input
          type="checkbox"
          checked={selectedTreeOrCard ? true : false}
          onChange={(e) => {}}
        />
        <div
          className={`${bottomSpace && "card-style"} switchBtn__slider ${
            setShape == "circle" ? "circleShape" : "squareShape"
          } ${setColor == "defaultColor" ? "defaultColor" : "customerColor"}`}
        ></div>
      </div>

      <div style={{ fontSize: "12px" }} className="me-2 userSelectNone">
        {trans(secondMode)}
      </div>
    </div>
  );
};
